import '../../styles-new/pages/redaction.scss';